import { QueryKey } from "@tanstack/react-query";
import { ServicePath } from "../../constants/apiConstants";
import { useFetchQuery } from "../core/rest/useFetchQuery";
import { objectToQueryString } from "../core/rest/useFetchQuery.utils";
import { User } from "./user.types";

type UsersQueryResult = {
  users: User[];
};

export function useGetUsers(entityId: number | undefined, limit: number = 1000) {
  const queryKey: QueryKey = ["users", entityId];
  const queryString = objectToQueryString({
    entity_id: entityId,
    limit,
    fields: "avatar,id,first_name,last_name,full_name,email,uuid,role,disabled",
  });
  const url = `${ServicePath.UsersV1}?${queryString}`;
  return useFetchQuery<UsersQueryResult>({
    queryKey,
    url,
    options: { enabled: !!entityId },
  });
}
